import {
    TOGGLE_MODAL,
    LOGOUT, TOGGLE_CONFIRM_DIALOG, CHANGE_DISPLAYED_USERS, CHANGE_USERS_LIST_SETTINGS, USERS_PAGE_SHIFT,
    RECEIVE_GET_USERS, REQUEST_GET_USERS, RECEIVE_BAD_REQUEST_GET_USERS, RECEIVE_POST_NEW_USER_RESPONSE,
    RECEIVE_PATCH_USER_RESPONSE
} from "../actions/index";
import {
    CHANGE_USER_LIST_STORE_SETTINGS,
    GET_ARAG_USER_BY_ID, GET_ARAG_USER_BY_ID_FAIL, GET_ARAG_USER_BY_ID_SUCCESS,
    GET_USER_GROUPS, GET_USER_GROUPS_FAIL, GET_USER_GROUPS_SUCCESS, GET_USER_LEVELS, GET_USER_LEVELS_FAIL,
    GET_USER_LEVELS_SUCCESS
} from "../actions";

const defaultState = {
	allUsers: [],
	initialReceiveALlUsers:false,
	selectedUsers: {},
	userSearchForm: "",
	usersListSettings: {
		displayAmount: 20,
		page: 1,
		value: '',
		suggestions: [],
		selectedSuggestions: [],
		action: "",
		selectedUser: {},
		selectedAction: ''
	},
	displayedUsers: [],
	displayModal: false,
	filterByUser: "noFilter",
	fetching: false,
	badFetchResponse: '',
	fetchingUserGroups: false,
	userGroups: [],
    fetchingUserLevels: false,
    userLevels: [],
	fetchingUserById: false,
	selectedAragUsers: {},
	allAragUsersSelected: false
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case CHANGE_USER_LIST_STORE_SETTINGS:
			return {
				...state,
				[action.payload.key]: action.payload.value
			};
		case GET_ARAG_USER_BY_ID:
			return {
				...state,
				fetchingUserById: true
			};
		case GET_ARAG_USER_BY_ID_SUCCESS:
			return {
				...state,
				fetchingUserById: false
			};
		case GET_ARAG_USER_BY_ID_FAIL:
			return {
				...state,
				fetchingUserById: false
			};
        case GET_USER_LEVELS:
            return {
                ...state,
                fetchingUserLevels: true
            };
        case GET_USER_LEVELS_SUCCESS:
            return {
                ...state,
                fetchingUserLevels: false,
                userLevels: action.payload.body
            };
        case GET_USER_LEVELS_FAIL:
            return {
                ...state,
                fetchingUserLevels: false
            };
		case GET_USER_GROUPS:
			return {
				...state,
                fetchingUserGroups: true
			};
		case GET_USER_GROUPS_SUCCESS:
			return {
				...state,
                fetchingUserGroups: false,
				userGroups: action.payload.body
			};
		case GET_USER_GROUPS_FAIL:
			return {
				...state,
                fetchingUserGroups: false
			};
		case RECEIVE_PATCH_USER_RESPONSE:
            for (let i = 0; i < state.allUsers.length; i++) {
                if (state.allUsers[i].id === action.payload.id.toString()) {
                    let newAllUsers = [...state.allUsers];
                    if (i !== 0) {
                        newAllUsers[i] = action.payload;
                    }
                    else {
                        newAllUsers[0] = action.payload;
                    }
                    return {
                        ...state,
                        allUsers: newAllUsers,
                        displayedUsers: newAllUsers
                    }
                }
            }
            return {
                ...state,
                allUsers: [action.payload, ...state.allUsers],
                displayedUsers: [action.payload, ...state.allUsers],
            };
		case RECEIVE_POST_NEW_USER_RESPONSE:
			return {
				...state,
                allUsers: [action.payload, ...state.allUsers],
                displayedUsers: [action.payload, ...state.allUsers],
			};
		case CHANGE_DISPLAYED_USERS:
			return {
				...state,
				displayedUsers: action.payload
			};
		case CHANGE_USERS_LIST_SETTINGS: {
			if (action.payload.key === 'displayAmount') {
				return {
					...state,
					usersListSettings: {
						...state.usersListSettings,
						[action.payload.key]: action.payload.value,
						page: 1
					},
                    selectedAragUsers: defaultState.selectedAragUsers,
                    allAragUsersSelected: defaultState.allAragUsersSelected
				}
			}
			else if (action.payload.key === 'page')
				return {
					...state,
					usersListSettings: {
						...state.usersListSettings,
						[action.payload.key]: action.payload.value
					},
                    selectedAragUsers: defaultState.selectedAragUsers,
                    allAragUsersSelected: defaultState.allAragUsersSelected
				};
			else if (action.payload.key === 'selectedSuggestions' ){
				return {
					...state,
					usersListSettings: {
						...state.usersListSettings,
						selectedSuggestions: action.payload.value,
						page: 1
					},
                    selectedAragUsers: defaultState.selectedAragUsers,
                    allAragUsersSelected: defaultState.allAragUsersSelected
				}
			}
			else {
				return {
					...state,
					usersListSettings: {
						...state.usersListSettings,
						[action.payload.key]: action.payload.value,
					}
				}
			}
		}
		case USERS_PAGE_SHIFT: {
			let counter = 0
			for (let i in state.displayedUsers) {
				counter++
			}
			let totalDisplayBoxes = Math.ceil(counter / state.usersListSettings.displayAmount);
			if (action.payload === 'left' && state.usersListSettings.page > 1) {
				return {
					...state,
					usersListSettings: {
						...state.usersListSettings,
						page: state.usersListSettings.page - 1,
					},
                    selectedAragUsers: defaultState.selectedAragUsers,
                    allAragUsersSelected: defaultState.allAragUsersSelected
				}
			}
			else if (action.payload === 'right' && state.usersListSettings.page < totalDisplayBoxes) {
				return {
					...state,
					usersListSettings: {
						...state.usersListSettings,
						page: state.usersListSettings.page + 1,
					},
                    selectedAragUsers: defaultState.selectedAragUsers,
                    allAragUsersSelected: defaultState.allAragUsersSelected
				}
			}
			else {
				return {
					...state,
                    selectedAragUsers: defaultState.selectedAragUsers,
                    allAragUsersSelected: defaultState.allAragUsersSelected
                }
			}
		}
		case RECEIVE_GET_USERS:
			return {
				...state,
				allUsers: action.payload.body,
				displayedUsers: action.payload.body,
				fetching: false,
                initialReceiveALlUsers: true
			};
		case REQUEST_GET_USERS:
			return {
				...state,
				fetching: true
			};
		case RECEIVE_BAD_REQUEST_GET_USERS:
			return {
				...state,
				fetching:false,
				badFetchResponse: action.payload
			};
		case TOGGLE_MODAL:
			return {
				...state,
				displayModal: !state.displayModal,
				displayConfirm: false
			};

		case LOGOUT:
			return {
				...defaultState
			};
		case TOGGLE_CONFIRM_DIALOG :
			return {
				...state,
				displayConfirm: !state.displayConfirm
			};
		case "@@router/LOCATION_CHANGE":
            return{
                ...state,
                selectedAragUsers: defaultState.selectedAragUsers,
                allAragUsersSelected: defaultState.allAragUsersSelected
            }
		default :
			return state
	}
}